
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    
/* eslint-disable global-require */
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import Script from 'next/script';
import theme from '../styling/theme';
import { StateProvider } from '../store/store';
import { useApollo } from '~/lib/apollo/apolloClient';
import '../sentry.client.config';

const MyApp = ({ Component, pageProps }) => {
  // Initialize lazysizes only in the browser, not on the server
  if (typeof window !== 'undefined') {
    require('lazysizes');
    require('lazysizes/plugins/attrchange/ls.attrchange');
    require('lazysizes/plugins/blur-up/ls.blur-up');

    // smoothscroll
    const smoothScroll = require('smoothscroll-for-websites/SmoothScroll');

    smoothScroll({
      animationTime: 250,
      stepSize: 50,
      accelerationDelta: 50,
      accelerationMax: 9,
      keyboardSupport: true,
      arrowScroll: 100,
      pulseAlgorithm: true,
      pulseScale: 5,
      pulseNormalize: 1,
      touchpadSupport: false,
      fixedBackground: true,
    });
  }

  const apolloClient = useApollo(pageProps);

  return (
    <>
      {process.env.gtm && (
        <Script
          id="gtmScript"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${process.env.gtm}')`,
          }}
        />
      )}
      {process.env.gtagId && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${process.env.gtagId}`}
            strategy="afterInteractive"
          />
          <Script id="google-analytics" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${process.env.gtagId}');
            `}
          </Script>
        </>
      )}
      <Script id="trengo-widget" strategy="afterInteractive">
        {`
          window.Trengo = window.Trengo || {};
          window.Trengo.key = 'MyNpRhw9ur7mtWamrU1j';
          (function(d, script) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://static.widget.trengo.eu/embed.js';
            d.getElementsByTagName('head')[0].appendChild(script);
          }(document));
        `}
      </Script>
      <ApolloProvider client={apolloClient}>
        <StateProvider>
          <ThemeProvider theme={theme}>
            <Component {...pageProps} />
            <style jsx>
              {`
                @font-face {
                  font-family: 'General Sans';
                  src: url('/fonts/GeneralSans-Regular.woff') format('woff'),
                    url('/fonts/GeneralSans-Regular.woff2') format('woff2');
                  font-weight: normal;
                  font-style: normal;
                  font-display: fallback;
                }
                @font-face {
                  font-family: 'General Sans';
                  src: url('/fonts/GeneralSans-Semibold.woff') format('woff'),
                    url('/fonts/GeneralSans-Semibold.woff2') format('woff2');
                  font-weight: 600;
                  font-style: normal;
                  font-display: fallback;
                }
                @font-face {
                  font-family: 'Kaleko 105';
                  src: url('/fonts/Kaleko-105-Regular.woff') format('woff'),
                    url('/fonts/Kaleko-105-Regular.woff2') format('woff2');
                  font-weight: normal;
                  font-style: normal;
                  font-display: fallback;
                }
                @font-face {
                  font-family: 'Kaleko 105';
                  src: url('/fonts/Kaleko-105-Bold.woff') format('woff'),
                    url('/fonts/Kaleko-105-Bold.woff2') format('woff2');
                  font-weight: 700;
                  font-style: normal;
                  font-display: fallback;
                }
                @font-face {
                  font-family: 'Kaleko 105 Remix';
                  src: url('/fonts/Kaleko-105-Remix-Regular.woff') format('woff'),
                    url('/fonts/Kaleko-105-Remix-Regular.woff2') format('woff2');
                  font-weight: normal;
                  font-style: normal;
                  font-display: fallback;
                }
              `}
            </style>
          </ThemeProvider>
        </StateProvider>
      </ApolloProvider>
    </>
  );
};

const __Page_Next_Translate__ = MyApp;


    export default __appWithI18n(__Page_Next_Translate__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      
    });
  